import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import useSnackBar from "../../Redux/hooks/useSnackBar";
import { useNavigate } from "react-router-dom";
import usePageLoader from "../../Redux/hooks/usePageLoader";
import { forgotPassword } from "../../Redux/Actions/AuthUser";
import CommonAuth from "../../Component/Common/CommonAuth";
import ErrorHandler from "../../lib/errorHandler";
import CommonTextField from "../../Component/Common/CommonTextField";
import ErrorMessage from "../../Component/Common/ErrorMessage";

const ForgotPassword = () => {
    // =================== Hooks ===================
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const navigate = useNavigate();

    // =================== States ===================
    const [values, setValues] = useState({ email: "" });
    const [errors, setErrors] = useState({ email: "" });

    // =================== handler ===================
    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const handleBack = () => {
        navigate('/login')
    };

    // =================== Validation ===================
    const validation = () => {
        let flag = false;
        let errors = {};

        if (!values.email) {
            errors.email = "Email is required";
            flag = true;
        } else if (!validateEmail(values.email)) {
            errors.email = "Invalid email format";
            flag = true;
        }
        setErrors(errors);
        return flag;
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    // =================== FotgotPassword API ===================
    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (validation()) {
            return;
        }
        setFullPageLoader(true);
        let response = await dispatch(forgotPassword(values));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setFullPageLoader(false);
            setSnackBar("success", `We Sent a password reset OTP to ${values.email}`)
            navigate(`/otp-verification?token=${btoa(values.email)}`);
        } else {
            setSnackBar("error", `please enter valid email address`)
            setFullPageLoader(false);
        }
        setFullPageLoader(false);

    };


    return (
        <CommonAuth
            submitButtonName={"Reset Password"}
            onButtonClick={handleResetPassword}
            boxShadow={"13px -5px 30px 0px rgba(29, 97, 205, 0.10)"}
            btnMarginTop={{ xs: "2rem", sm: "2rem", md: "2.5rem" }}
            children={
                <>
                    <Typography sx={{ fontSize: { xs: "20px", sm: "26px", md: "28px" }, color: "#131313", fontFamily: "Satoshi-Bold !important", mt: { xs: "10px", sm: "30px", md: "50px" }, }}>
                        {"Forgot Password ?"}
                    </Typography>
                    <Grid container spacing={3} mt={1}>
                        <Grid item xs={12}>
                            <CommonTextField
                                isEmail
                                type={"email"}
                                label={"Email"}
                                color={"#E77843 !important"}
                                placeholder={"Enter Your Email"}
                                value={values.email}
                                onChange={onChangeHandler}
                                name="email"
                            />
                            <ErrorMessage text={errors.email} />
                        </Grid>
                    </Grid>
                </>
            }
            children2={
                <>
                    <Box sx={{ display: "flex", alignItems: "center", margin: { xs: "1.5rem 0 0", sm: "2rem 0 0", md: "3rem 0 0", }, cursor: "pointer", }} onClick={handleBack}>
                        <img src="/assets/img/backArrow.svg" />
                        <Typography sx={{ ml: 1, color: "#8D8D8D", fontSize: "14px", fontWeight: "500", fontFamily: "Satoshi-Medium" }}>
                            Back To login
                        </Typography>
                    </Box>
                </>
            }
        />
    );
};

export default ForgotPassword;
